import { addDoc, collection, serverTimestamp, updateDoc, doc, getDoc } from "firebase/firestore";
import { ref, uploadBytes, getDownloadURL } from "firebase/storage";
import { db, storage } from "../config/firebase";

export const sendMessage = async (chatId, user, text, file = null, audioBlob = null) => {
  try {
    // First, check if the chat/booking is active (lawyer has accepted)
    const chatRef = doc(db, 'chats', chatId);
    const chatDoc = await getDoc(chatRef);
    
    if (!chatDoc.exists()) {
      throw new Error('Chat not found');
    }
    
    const chatData = chatDoc.data();
    
    // Check if the booking status is 'active' (lawyer has accepted)
    if (chatData.status !== 'active') {
      throw new Error('Chat is not active. Please wait for the lawyer to accept your request.');
    }
    
    let fileUrl = null;
    let fileType = null;
    let messageType = 'text';

    // Handle file upload
    if (file) {
      const fileRef = ref(storage, `chats/${chatId}/files/${Date.now()}-${file.name}`);
      await uploadBytes(fileRef, file);
      fileUrl = await getDownloadURL(fileRef);
      fileType = file.type;
      messageType = file.type.startsWith('image/') ? 'image' : 'file';
    }

    // Handle audio upload
    if (audioBlob) {
      const audioRef = ref(storage, `chats/${chatId}/voice/${Date.now()}.webm`);
      await uploadBytes(audioRef, audioBlob, { contentType: "audio/webm" });
      fileUrl = await getDownloadURL(audioRef);
      fileType = "audio/webm";
      messageType = 'voice';
    }

    // Create message data
    const messageData = {
      text: text || (file ? file.name : ""),
      content: text || (file ? file.name : ""), // Use filename for file messages
      senderId: user.uid,
      senderName: user.displayName || user.full_name || 'Client',
      senderProfilePic: user.photoURL || user.profile_picture || '/default-avatar.png',
      type: messageType,
      fileUrl,
      fileType,
      createdAt: serverTimestamp(),
      timestamp: new Date().toISOString(), // Add timestamp for compatibility
    };

    // Add message to Firestore
    await addDoc(collection(db, "chats", chatId, "messages"), messageData);
    
    // Update chat document with last message info
    const chatUpdateRef = doc(db, "chats", chatId);
    await updateDoc(chatUpdateRef, {
      lastMessage: text || (file ? 'File sent' : 'Voice message'),
      lastMessageTime: serverTimestamp(),
      updatedAt: serverTimestamp()
    });
    
    console.log("Message sent successfully");
  } catch (err) {
    console.error("Error sending message:", err);
    throw err;
  }
};
